import {Box, Typography} from "@material-ui/core";
import './CasesView.css'
import {useState} from "react";

interface IAnimatedLineProps {
    animate: boolean;
    onAnimationEnd: () => void;
    animationKey: string
}

function AnimatedLine(props: IAnimatedLineProps) {
    // return <div className="CaseLine"/>
    return <div style={{width: "82px", height: "2px", position: "relative"}}>
        <div className="CaseLine"/>
        {props.animate && <div key={props.animationKey} className="CaseLineFilled" onAnimationEnd={props.onAnimationEnd}/>}
    </div>;
}

interface ICasesViewProps {
    cases: ICaseItem[]
}

interface ICaseItem {
    title: string
    icon: string
}

export default function CasesView(props: ICasesViewProps) {
    const [state, setState] = useState({selectedIndex: 0, animationsKey: "123"});

    const lines = [0, 1, 2].map((number) =>
        <AnimatedLine
            animate={state.selectedIndex >= number}
            animationKey={state.animationsKey}
            onAnimationEnd={() => setState({
                selectedIndex: number == 2 ? 0 : number + 1,
                animationsKey: number == 2 ? state.animationsKey + "1" : state.animationsKey
            })
            }
        />
    )

    return <div style={{display: "flex", flexDirection: "column", alignItems: "start"}}>
        <img src={props.cases[state.selectedIndex].icon} style={{width: "100%", marginTop: "16px", height: "513px", backgroundColor: "transparent"}}/>
        <Box height="19px"/>
        <div className="Cases_view_lines_container">
            {lines}
        </div>
        <Box height="10px"/>
        <span className="Cases_view_title">{props.cases[state.selectedIndex].title}</span>
    </div>
}

